import React from 'react'
import Done from '@material-ui/icons/Done'
interface StepperProps {
  uiClasses: any
  activeStep: number
}

const Stepper: React.FC<StepperProps> = ({ uiClasses, activeStep }) => {
  return (
    <div className={uiClasses.stepperContainer}>
      <div>
        <div className={uiClasses.stepItem}>
          {activeStep === 0 && (
            <div
              className={uiClasses.stepNumber}
              style={{
                backgroundColor: activeStep === 0 ? 'var(--color-text-blue)' : 'var(--color-text-white)',
                color: activeStep === 0 ? 'var(--color-white)' : 'var(--color-text-gray)',
                border: activeStep === 0 ? '2px solid var(--color-text-blue)' : '2px solid var(--color-text-gray)',
              }}>
              01
            </div>
          )}
          {activeStep === 1 && (
            <div
              className={uiClasses.stepNumber}
              style={{
                backgroundColor: 'transparent',
                color: 'rgba(34, 184, 39, 1)',
                border: '2px solid rgba(34, 184, 39, 1)',
              }}>
              <Done />
            </div>
          )}
          <div
            className={uiClasses.stepLabel}
            style={{ color: activeStep === 0 ? 'var(--color-text-blue)' : 'var(--color-text-gray)' }}>
            Setup
          </div>
          <div className={uiClasses.stepConnector}></div>
        </div>
        <div className={uiClasses.stepItem}>
          <div
            className={uiClasses.stepNumber}
            style={{
              backgroundColor: activeStep === 1 ? 'var(--color-text-blue)' : 'var(--color-text-white)',
              color: activeStep === 1 ? 'var(--color-white)' : 'var(--color-text-gray)',
              border: activeStep === 1 ? '2px solid var(--color-text-blue)' : '2px solid var(--color-text-gray)',
            }}>
            02
          </div>
          <div
            className={uiClasses.stepLabel}
            style={{ color: activeStep === 1 ? 'var(--color-text-blue)' : 'var(--color-text-gray)' }}>
            Questions
          </div>
        </div>
      </div>
      <div className={uiClasses.infoSection}>
        <div className={uiClasses.infoIcon}>
          <div
            style={{
              backgroundColor: 'var(--color-text-blue)',
              width: 24,
              height: 24,
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: 18,
              fontWeight: 'bold',
              color: 'var(--color-white)',
            }}>
            ?
          </div>
        </div>
        <h3 className={uiClasses.infoTitle}>What happens here?</h3>
        <p className={uiClasses.infoText}>
          Create and manage supervision questions to help managers assess their team's progress.
        </p>
      </div>
    </div>
  )
}

export default Stepper
